import useAppRouter from '../../../hooks/useAppRouter';
import useIsShowWebCheckInComponents from '../../../utils/callbackUrl/useIsShowWebCheckInComponents';

const useWebCheckInCallback = () => {
  const { callbackUrl } = useAppRouter().states;
  const { isShowWebCheckInComponents } = useIsShowWebCheckInComponents().states;
  return {
    states: {
      showWebCheckInBanner: isShowWebCheckInComponents,
      callbackUrl,
    },
  };
};

export default useWebCheckInCallback;
